import { HttpUtil } from '@/net/HttpUtil'
import { SimpleEventEmitter } from '@/utils/functions'
import { UIHudSystem } from '@/utils/UIHudSystem'

export class base {
  static channelId: number = 3

  static sdkWrapper: any = null
  static toast: any = null
  static app: any = null
  static uiHudSystem: UIHudSystem = new UIHudSystem()
  static httpUtil: HttpUtil = new HttpUtil()
  static Utility: any = null
  static eventDispatcher: SimpleEventEmitter = new SimpleEventEmitter()
  static publish: boolean = false
}
